import { TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Table, Typography, Box } from '@material-ui/core';
import { Edit } from '@material-ui/icons'
import React, { Fragment } from 'react';
import { EmailTemplate } from '../../../interfaces/examiner/EmailTemplate';
import request from '../../../api';
import { examinerHasRole } from '../../../components/RoleAccess';
import EditEmailTemplateDialog from './EditEmailTemplateDialog';
import SendEmailComposer from './SendEmailComposer';

interface Props {
}

interface State {
  data: EmailTemplate[] | null
  totalRows: number
  rowsPerPage: number
  page: number
  sortColumn: string
  sortOrder: 'asc' | 'desc',
  searchQuery: string
  editTemplateDialog: EmailTemplate | null
}

export default class ExaminerEmailsList extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props)
    this.state = {
      data: [],
      totalRows: 0,
      rowsPerPage: 10,
      page: 1,
      sortColumn: 'name',
      sortOrder: 'asc',
      searchQuery: '',
      editTemplateDialog: null
    }
  }

  async componentDidMount() {
    await this.reload()
  }

  async reload() {
    try {
      const res = await request('/api/examiner/email-templates', {
        method: 'GET',
        headers: { 'content-type': 'application/json' }
      })
      const templates = await res.json()
      this.setState({
        data: templates,
        totalRows: templates.length
      })
    } catch (error) {
      console.error('Error loading email templates:', error)
    }
  }

  columns: any[] = [
    {
      name: 'Template Name',
      selector: 'name',
      sortable: true,
      cell: (template: EmailTemplate) => {
        // Convert snake_case to readable format
        return template.name.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
      }
    },
    {
      name: 'Subject',
      selector: 'subject',
      sortable: true,
      cell: (template: EmailTemplate) => {
        // Show first 50 chars of subject
        const subject = template.subject || ''
        return subject.length > 50 ? subject.substring(0, 50) + '...' : subject
      }
    },
    {
      name: 'Last Updated',
      selector: 'updatedAt',
      sortable: true,
      cell: (template: EmailTemplate) => {
        return template.updatedAt ? new Date(template.updatedAt).toLocaleDateString() : 'Never'
      }
    },
    {
      name: 'Edit',
      cell: (template: EmailTemplate) =>
        <Fragment>
          <Edit style={{ cursor: 'pointer' }} onClick={() => this.handleEditTemplate(template)} />
        </Fragment>
    }
  ]

  handleEditTemplate = (template: EmailTemplate) => {
    this.setState({ editTemplateDialog: template })
  }

  handleCloseEditDialog = () => {
    this.setState({ editTemplateDialog: null })
  }

  handleTemplateUpdated = () => {
    this.handleCloseEditDialog()
    this.reload()
  }

  render() {
    const { data, editTemplateDialog } = this.state

    return (
      <Fragment>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Template Name</TableCell>
                <TableCell>Subject</TableCell>
                <TableCell>Last Updated</TableCell>
                <TableCell>Edit</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data && data.map((template) => (
                <TableRow key={template.id}>
                  <TableCell>{template.name.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}</TableCell>
                  <TableCell>{template.subject && template.subject.length > 50 ? template.subject.substring(0, 50) + '...' : template.subject}</TableCell>
                  <TableCell>{template.updatedAt ? new Date(template.updatedAt).toLocaleDateString() : 'Never'}</TableCell>
                  <TableCell>
                    <Edit style={{ cursor: 'pointer' }} onClick={() => this.handleEditTemplate(template)} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        {examinerHasRole(['admin', 'superuser']) && (
          <Box mt={4} mb={10}>
            <Box
              style={{
                background: '#55aaff',
                marginTop: 24,
                padding: '12px 16px',
                borderRadius: '6px 6px 0 0'
              }}
            >
              <Typography variant="h6" style={{ color: '#fff', margin: 0 }}>
                Send Email
              </Typography>
            </Box>
            <SendEmailComposer />
          </Box>
        )}
        {editTemplateDialog && (
          <EditEmailTemplateDialog
            template={editTemplateDialog}
            open={true}
            onClose={this.handleCloseEditDialog}
            onUpdated={this.handleTemplateUpdated}
          />
        )}
      </Fragment>
    )
  }
}

